import { PaymentMethod } from "./paymentMethodModel";

export class PaymentMethodResponse{
    environment!:string;
    paymentMethods!: PaymentMethod[];
}